import { memo } from "react";
import { useNavigate } from "react-router-dom";

import { useAudio, useAuth, useChatInteract, useConfig } from "@chainlit/react-client";

import AudioPresence from "@/components/AudioPresence";
import ButtonLink from "@/components/ButtonLink";
import { useSidebar } from "@/components/ui/sidebar";

import ApiKeys from "./ApiKeys";
import ChatProfiles from "./ChatProfiles";
import NewChatButton from "./NewChat";
import ReadmeButton from "./Readme";
import ShareButton from "./Share";
import SidebarTrigger from "./SidebarTrigger";
import { ThemeToggle } from "./ThemeToggle";
import UserNav from "./UserNav";
import CloseIframeButton from "./Close";
import { Button } from "../ui/button";
import PersonEmojie from "../icons/Person";
import { useIsMobile } from "@/hooks/use-mobile";
import { useTheme } from "../ThemeProvider";

const Header = memo(() => {
  const { audioConnection } = useAudio();
  const navigate = useNavigate();
  const { data } = useAuth();
  const { config } = useConfig();
  const { open, openMobile, isMobile } = useSidebar();
  const { sendMessage, replyMessage } = useChatInteract();
  const sidebarOpen = isMobile ? openMobile : open;
  const theme = useTheme()
  const historyEnabled = data?.requireLogin && config?.dataPersistence;

  const links = config?.ui?.header_links || [];

  return (
    <div
      className="p-3 flex h-[60px] items-center justify-between gap-2 relative"
      id="header"
    >
      {isMobile &&
        (
          <div className="flex items-center">
            {historyEnabled ? !sidebarOpen ? <SidebarTrigger /> : null : null}
            {historyEnabled
              ? (
                !sidebarOpen ? <NewChatButton navigate={navigate} /> : null
              )
              : <NewChatButton navigate={navigate} />}

            <ChatProfiles navigate={navigate} />
          </div>
        )}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        {audioConnection === "on"
          ? (
            <AudioPresence
              type="server"
              height={35}
              width={70}
              barCount={4}
              barSpacing={2}
            />
          )
          : null}
      </div>

      <div />
      <div className="flex hover:*:bg-[hsl(var(--popover))] items-center gap-5">
        <ShareButton />
        <ReadmeButton />
        <ApiKeys />
        {links &&
          links.map((link, index) => (
            <ButtonLink
              key={`${link.name}-${link.url}-${index}`}
              name={link.name}
              displayName={link.display_name}
              iconUrl={link.icon_url}
              url={link.url}
              target={link.target}
            />
          ))}

        {
          !isMobile && <Button
            id="theme-toggle"
            variant="ghost"

            className={`hover:cursor-pointer light:bg-[#78887E] light:hover:bg-[#000] dark:text-[#78887E] light:text-[#000000]`}
            onClick={() => sendMessage({ command: "Talk to a human", name: "Talk To support", output: "Talk To support", type: "user_message" })}><PersonEmojie /> Talk to a Human</Button>
        }

        {/* <ThemeToggle /> */}
        <UserNav />
        <CloseIframeButton />
      </div>
    </div>
  );
});

export { Header };
